<template>
    <router-link :to="{name:route, params:{id: id}}" class="btn btn-success rounded-0 me-1">
        <i class="m-0 edit outline icon"></i>
    </router-link>
</template>

<script>
export default {
    name: "ButtonEdit",

    props: {
        route: {
            'type': String,
            "required": true,
        },

        id: {
            'type': Number,
            "required": true,
        }
    },
}
</script>
